import { Component, Input } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { SKILL_CODES } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-skill-code-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './skill-code-dropdown-field.component.html',
	styleUrl: './skill-code-dropdown-field.component.scss',
})
export class SkillCodeDropdownFieldComponent extends BaseFieldComponent {
	@Input('multiple') public multiple: boolean = false;

	public options: DropdownOption[] = SKILL_CODES.map(code => ({
		value: code,
		label: code,
	}));

	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 4:30:09 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [];
}
